<template lang="html">
  <div>
    <div class="ex_header_top">
      <van-nav-bar
        title="兑换记录"
        left-arrow
        fixed
        @click-left="onClickLeft"/>
    </div>
    <div class="ex_content">
      <ul>
        <li v-for="(item, index) in exchangeList" :key="index">
          <span>兑换商品：{{item.name}}</span>
          <span>兑换实果：{{item.cur_price}}果实</span>
          <span>兑换时间：{{item.dateline}}</span>
          <em v-if="item.status == 0">处理中</em>
          <em v-else="item.status == 1">已完成</em>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import utilAxios from '@/utils/axios'
import { NavBar } from 'vant'

Vue.use(NavBar)
export default {
  data (){
    return{
      exchangeList: []
    }
  },
  created() {
    this.getExchangeData()
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    getExchangeData() {
      utilAxios.get({
        url: '/new_api.php?module=auction&act=my&filter=got',
        method: 'GET',
        callback: (res) => {
          if(res.data.code == 100){
            this.exchangeList = res.data.list
            console.log(this.exchangeList);
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .ex_content{
    margin-top: .46rem;
    width: 100%;
    ul{
      background: #FFF;
      li{
        padding: .1rem;
        border-bottom: 1px solid #EEE;
        position: relative;
        span{
          display: block;
          height: .3rem;
          line-height: .3rem;
        }
        em{
          position: absolute;
          top: 45%;
          right: .2rem;
          color: red;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Exchange/Exchange.vue